import * as Scrivito from "scrivito";
import { getKeycloak } from "^/Components/Authentication/keycloak";
import { useAuth } from "^/Components/Authentication/AuthenticationProvider";
import FavLinks from "^/Components/Footer/FavLinks";
import FooterContent from "^/Components/Footer/FooterContent";
import { isLiv } from "^/utils/isLiv";
import Breadcrumb from "^/Components/Breadcrumb";
import TikTokIcon from "^/Components/Footer/TikTokIcon";
import Logo from "./Navigation/Logo";
import getHomepage from "../utils/getHomepage";

function Footer() {
  const currentPage = Scrivito.currentPage();
  const isHomepage = currentPage?.objClass() === "Homepage";
  const homepage = getHomepage(currentPage);
  const { authenticated } = useAuth();

  if (!homepage) {
    return null;
  }
  const favLinks = homepage.get("favLinks") || [];
  const footerSocialLinks = homepage.get("footerSocialLinks") || [];
  const footerLinks = homepage.get("footerLinks") || [];

  if (!footerSocialLinks || !footerLinks) {
    return null;
  }

  return (
    <footer>
      <section className="p-1">
        {!isHomepage && (
          <div className="container">
            <Breadcrumb />
          </div>
        )}
      </section>
      <FavLinks links={favLinks} />
      <FooterContent page={homepage} />
      <div className="footer-final">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-2">
              <Logo />
            </div>
            <div className="col-12 col-sm-10">
              <ul className="footer-final-social-links">
                {footerSocialLinks.map((socialLink) => (
                  <li key={`${socialLink.title()}-${socialLink.url()}`}>
                    <Scrivito.LinkTag
                      title={socialLink.title()}
                      to={
                        new Scrivito.Link({
                          url: socialLink.url(),
                          target: "_blank",
                          rel: "noopener noreferrer nofollow",
                        })
                      }
                    >
                      {socialLink.title() === "tiktok" ? (
                        <TikTokIcon />
                      ) : (
                        <i
                          title={socialLink.title()}
                          className={`lab la-2x la-${socialLink.title()}`}
                        />
                      )}
                    </Scrivito.LinkTag>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <ul className="footer-final-links">
                <li>&copy; {new Date().getFullYear()} HHN</li>
                {footerLinks.map((link, index) => (
                  <li key={index}>
                    <Scrivito.LinkTag to={link}>
                      {link.title() ||
                        (link.isInternal()
                          ? link.obj().get("title")
                          : link.url())}
                    </Scrivito.LinkTag>
                  </li>
                ))}
                {!isLiv(currentPage) && authenticated && (
                  <li>
                    <a
                      href="#"
                      onClick={() => {
                        window.localStorage.setItem(
                          "keycloakLoginPresent",
                          "false"
                        );
                        getKeycloak().logout({
                          redirectUri: window.location.origin,
                        });
                      }}
                    >
                      Logout
                    </a>
                  </li>
                )}
                {!isLiv(currentPage) && !authenticated && (
                  <li>
                    <a
                      href="#"
                      onClick={() =>
                        getKeycloak().login({
                          redirectUri: `${window.location.origin}/de/login-redirect-de`,
                        })
                      }
                    >
                      Intranet
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Scrivito.connect(Footer);
